import { MasqueradeUserType } from './types';

export const USER: string = 'userToken';
export const SELLER: string = 'sellerToken'; // <VERTICAL PREFIX>_<id>_<hash>
export const MASQUERADE_BUYER: MasqueradeUserType = 'masqueradeBuyer'; // U_<id>
export const MASQUERADE_BUYER_USER_TOKEN: string = 'masqueradeBuyerUserToken';
export const MASQUERADE_SELLER: MasqueradeUserType = 'masqueradeSeller'; // S_<id>_<VERTICAL PREFIX>
export const USER_TYPE: string = 'userType';
export const REAL_USER_TYPE: string = 'realUserType';
export const USER_EMAIL: string = 'userEmail';
export const USER_EMAIL_TOKEN: string = 'userEmailToken';
export const USER_LEGACY: string = 'userreg';
export const GUEST_ID: string = 'guestId';
export const EVER_LOGGED_IN: string = 'eli';
export const PASSWORD_RESET: string = 'passwordToken';
export const AB_TEST_ELIGIBILITY: string = 'abe';

export const COOKIE_KEYS = {
    USER,
    SELLER,
    MASQUERADE_BUYER,
    MASQUERADE_BUYER_USER_TOKEN,
    MASQUERADE_SELLER,
    USER_TYPE,
    REAL_USER_TYPE,
    USER_EMAIL,
    USER_EMAIL_TOKEN,
    USER_LEGACY,
    GUEST_ID,
    EVER_LOGGED_IN,
    PASSWORD_RESET,
    AB_TEST_ELIGIBILITY,
};
